import { LED_BASE_ROUTE } from 'config/led/routes';
import { RETAIL_BASE_ROUTE } from 'config/retail/routes';
import {
  batteryBg,
  batteryBgMob,
  evChargingBg,
  evChargingBgMob,
  rebatesBg,
  rebatesBgMob, retailEnergyBg,
} from 'assets/images/home';
import {BATTERY_URL, EV_CHARGING_URL, REBATES_URL, RETAIL_URL} from 'config/seo/urls';
import {batteryImage, evChargingImage, rebatesImage, retailImage} from "../../assets/images/about-us";

export const E5_APP_LINK = 'https://energy5.page.link/services';
export const E5_APP_COOKIE = 'e5AppCookie';
export const E5_APP_COOKIE_DAYS = 365;
export const E5_APP_COOKIE_OPTIONS = { maxAge: E5_APP_COOKIE_DAYS * 24 * 3600 };
export const E5_APP_ROUTES = [LED_BASE_ROUTE, RETAIL_BASE_ROUTE, '/ev-charging'];


export const STATIC_SERVICES = [
  {
    key: 'ev-charging',
    title: 'Ev',
    subtitle: 'charging',
    caption: 'home.header.new.start-ev-charging',
    imgSrc: evChargingBg,
    imgSrcMob: evChargingBgMob,
    url: EV_CHARGING_URL,
    description: 'From permitting to purchase and installation to software management, financing, and incentive paperwork – Energy5 offers end-to-end turnkey EV Charging solutions for your business',
  },
  {
    key: 'rebates',
    title: 'Rebates',
    caption: 'home.header.new.upgrade-your-lightning',
    imgSrc: rebatesBg,
    imgSrcMob: rebatesBgMob,
    zipInput: true,
    url: REBATES_URL,
    description: 'With our turnkey rebate services, we handle every detail from paperwork to compliance so you can enjoy maximum savings effortlessly.',
  },
  {
    key: 'battery-storage',
    title: 'Battery Storage',
    caption: 'home.header.new.upgrade-your-lightning',
    imgSrc: batteryBg,
    imgSrcMob: batteryBgMob,
    zipInput: true,
    url: BATTERY_URL,
    description: 'Power your peace of mind with reliable battery storage solutions. Ensure uninterrupted energy supply and harness the full potential of renewable energy sources.',
  },
  // {
  //   key: 'retail-energy',
  //   title: 'home.header.new.retail-energy',
  //   caption: 'home.header.new.upgrade-your-lightning',
  //   imgSrc: retailEnergyBg,
  //   zipInput: true,
  //   url: RETAIL_URL,
  //   description: 'Be it business or residential electricity rates, just fill the form and get the best energy plans in your area. Start save on energy today',
  // },
]

export const STATIC_ABOUT_US_SERVICES = [
  {
    key: 'ev-charging',
    title: 'Ev',
    subtitle: 'charging',
    caption: 'home.header.new.start-ev-charging',
    imgSrc: evChargingImage,
    url: EV_CHARGING_URL,
    description: 'From permitting to purchase and installation to software management, financing, and incentive paperwork – Energy5 offers end-to-end turnkey EV Charging solutions for your business',
  },
  {
    key: 'rebates',
    title: 'Rebates',
    caption: 'home.header.new.upgrade-your-lightning',
    imgSrc: rebatesImage,
    zipInput: true,
    url: REBATES_URL,
    description: 'With our turnkey rebate services, we handle every detail from paperwork to compliance so you can enjoy maximum savings effortlessly.',
  },
  {
    key: 'battery-storage',
    title: 'Battery Storage',
    caption: 'home.header.new.upgrade-your-lightning',
    imgSrc: batteryImage,
    zipInput: true,
    url: BATTERY_URL,
    description: 'Power your peace of mind with reliable battery storage solutions. Ensure uninterrupted energy supply and harness the full potential of renewable energy sources.',
  },
  {
    key: 'retail-energy',
    title: 'home.header.new.retail-energy',
    caption: 'home.header.new.upgrade-your-lightning',
    imgSrc: retailImage,
    zipInput: true,
    url: RETAIL_URL,
    description: 'Be it business or residential electricity rates, just fill the form and get the best energy plans in your area. Start save on energy today',
  },
]
